var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useSetAtom } from 'jotai';
import { useSearchParams } from 'react-router';
import { Translate } from "../../../../../../I18N";
import { Button } from "../../../../../Components/UI";
import { FunnelIcon } from '@heroicons/react/24/solid';
import { filterSidepanelAtom } from "./filterSidepanelAtom";

const FilterSidepanelButton = () => {
  const setOpen = useSetAtom(filterSidepanelAtom);
  const [searchParams] = useSearchParams();
  const activeFilters = Array.from(searchParams.entries()).filter(([key]) => key !== 'page').length;
  return (/*#__PURE__*/
    _jsx(Button, {
      className: "flex items-center gap-2 leading-4 text-gray-800",
      styling: "light",
      onClick: () => setOpen(true) }, void 0, /*#__PURE__*/

    _jsx(FunnelIcon, {
      className: `inline w-4 mr-2 ${activeFilters > 0 ? 'text-primary-900' : 'text-gray-800'} ` }
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Filters"),
    activeFilters > 0 && /*#__PURE__*/
    _jsx("span", { className: "px-3 py-[2px] ml-2 text-xs text-white rounded-md bg-primary-900" }, void 0,
    activeFilters
    )

    ));

};

export { FilterSidepanelButton };